module.exports = __webpack_public_path__ + "static/media/FAAC.84b140be.jpg";